import { memo } from 'react';
import { Field } from 'react-final-form';
import { SplitDate } from '../inputs';

const SplitDateField = memo(props => (
  <Field
    {...props}
    parse={val => val ?? '--'}
    format={value => value}
    render={({ input, meta }) => <SplitDate {...props} {...input} errors={meta.submitError} />}
  />
));

SplitDateField.propTypes = SplitDate.propTypes;
SplitDateField.defaultProps = SplitDate.defaultProps;

export default SplitDateField;
